/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-08-16 14:11:09
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-08 10:19:07
 */
/* eslint-disable react-hooks/exhaustive-deps */
import { unwrapResult } from "@reduxjs/toolkit";
import { Radio } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import { MultipleYLine } from "../../components/MultipleYLine";
import styles from "./ProportionDataAnaylse.module.css";
import { getProvinceDataContrastData } from "./ProvinceDataAnaylseSlice";

export const ProvinceProportionContrast = () => {
  const [time, setTime] = useState(2);

  const [medicalData, setMedicalData] = useState<any>([]);

  const [cautionData, setCautionData] = useState<any>([]);

  const [handleData, setHandleData] = useState<any>([]);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(getProvinceDataContrastData(time))
      .then(unwrapResult)
      .then((res) => {
        setMedicalData(
          res.map((v) => {
            return v.medicalTotal;
          })
        );
        setCautionData(
          res.map((v) => {
            return v.cautionTotal;
          })
        );
        setHandleData(
          res.map((v) => {
            return v.handleTotal;
          })
        );
      });
  }, [time]);

  return (
    <div className={styles.contranst}>
      <div className={styles.select}>
        <h3>浙江省监管数据变化图</h3>
        <Radio.Group
          defaultValue={time}
          onChange={(e: any) => {
            setTime(e.target.value);
          }}
          optionType="button"
          buttonStyle="solid"
        >
          <Radio.Button value={0}>近七天</Radio.Button>
          <Radio.Button value={1}>近30天</Radio.Button>
          <Radio.Button value={2}>近一年</Radio.Button>
        </Radio.Group>
      </div>
      <div className={styles.content}>
        <MultipleYLine
          timeQuantum={time}
          firstData={medicalData}
          secondData={cautionData}
          thirdData={handleData}
          style={{ height: "100%" }}
        />
      </div>
    </div>
  );
};
